<template>
  <footer class="page-footer font-small">
    <div class="container-fluid bg-light">
      <div class="row">
        <div class="col-md-12 py-2">
          <div class="text-center">
            <!-- <a
              :href="$t(domainWithoutDot + '.social.facebook')"
              target="_blank"
              class="fb-ic text-dark mr-md-5 mr-3"
            >
              <i class="fa fa-facebook" />
            </a> -->
            <!--
            <a
              href="#"
              class="ins-ic text-dark mr-md-5 mr-3"
            >
              <i class="fa fa-instagram" />
            </a>
            -->
          </div>
        </div>
      </div>
    </div>
    <div class="footer-copyright text-center py-3 bg-dark text-white">
      © 2018 Copyright:
      <a :href="`http://${domain}`">
        {{ domain }}
      </a>
      |
      <RouterLink
        to="/privacy-policy"
      >
        {{ $t('privacy') }}
      </RouterLink>
    </div>
  </footer>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters(['domain', 'domainWithoutDot']),
  },
};
</script>
